import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "../providers/SnackbarProvider";

export function useFirebaseAuthErrorHandler() {
  const { showSnackbar } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {
    const originalConsoleError = console.error;

    const networkErrorCodes = [
      "auth/network-request-failed",
      "auth/internal-error",
    ];

    const isNetworkError = (code: string) => networkErrorCodes.includes(code);

    console.error = (...args: unknown[]) => {
      const hasNetworkError = args.some((arg) => {
        if (arg && typeof arg === "object" && "code" in arg) {
          return isNetworkError((arg as { code: string }).code);
        }
        return false;
      });

      if (hasNetworkError) {
        navigate("/", { replace: true });
        showSnackbar(
          "It seems there is a connection issue. Please check your internet connection.",
          {
            type: "error",
            duration: null,
          }
        );
      }

      originalConsoleError.apply(console, args);
    };

    return () => {
      console.error = originalConsoleError;
    };
  }, [showSnackbar, navigate]);
}
